import { CommonAction } from '../../../login/redux/types';
import AnnouncementsTypes, { AnnoucementState } from './types';

const AnnoucementInitialState: AnnoucementState = {
    loading: false,
    annoucement: [],
};

const AnnoucementReducer = (state = AnnoucementInitialState, action: CommonAction): AnnoucementState => {
    switch (action.type) {
        case AnnouncementsTypes.FETCH_ANNOUNCEMENTS_REQ:
            return {
                ...state,
                loading: true,
                annoucement: [],
            };
        case AnnouncementsTypes.SET_ANNOUNCEMENTS:
            return {
                ...state,
                loading: false,
                annoucement: action.payload,
            };
        default:
            return state;
    }
};

export default AnnoucementReducer;
